<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.el-col-5 {
  width: 33%;
}

.filePopoverA {
  text-decoration: underline;
  color: #4fa1a4;
}

.filePopover {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  cursor: pointer;
}

.downloadTemplate {
  color: #fff;
  background: #4fa1a4;
  padding: 9px 15px;
  border-radius: 3px;
  display: inline-block;
}

/* .search-area {
    width: 68% !important;
  } */
.age-box {
  flex: 1;
  display: flex;
  align-items: center;
  /* padding-left: 12px; */
  box-sizing: border-box;
}

.age-box span {
  margin: 0 5px;
}

.search-area-div {
  flex-shrink: 0;
}

.search-block .el-col-6 {
  margin-top: 15px;
}

.search-area-div {
  width: 90px;
  text-align: left;
}

.ipt-sty {
  width: calc(100% - 93px) !important;
}
::v-deep .el-table__row .el-tablerow--striped .hover-row {
  max-width: 1500px;
}
::v-deep .el-tooltip__popper.is-dark {
  /* 添加自定义样式 */
  background: #fff !important;
  color: #272822;
  z-index: 2009;
  /* 其他样式属性... */
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
::v-deep .dialog-reason .el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
::v-deep .dialog-reason .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style>
.el-tooltip__popper.is-dark {
  /* 添加自定义样式 */
  background: #fff !important;
  color: #272822;
  z-index: 2009;
  border: 1px solid #000;
  /* 其他样式属性... */
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">人员/手机号</div>
          <el-input
            class="ipt-sty"
            size="mini"
            v-model="searchData.staffOrMobileNo"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">备案公司</div>
          <el-select
            size="mini"
            v-model="searchData.tenantGuid"
            placeholder="请选择"
            class="ipt-sty"
            clearable
            filterable
            @change="chooseCompany"
          >
            <el-option
              v-for="item in tenantGuidOption"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">备案部门</div>
          <el-select
            size="mini"
            v-model="searchData.orgGuid"
            placeholder="请选择"
            class="ipt-sty"
            clearable
            filterable
            @visible-change="hasCompany"
            @change="chooseOrg"
          >
            <el-option
              v-for="item in orgGuidOption"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="expand" @click="searchShow = !searchShow"
            ><i
              :class="
                searchShow ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'
              "
            ></i
            >{{ searchShow ? "收起筛选" : "更多筛选" }}</el-button
          >
          <el-button size="mini" type="info" @click="comfirmSearch"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <div class="search-block" v-if="searchShow">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">转正状态</div>
            <el-select
              size="mini"
              v-model="searchData.staffStatus"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in regularStatusOption"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">转正时间</div>
            <el-date-picker
              size="mini"
              v-model="regularTime"
              class="ipt-sty"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">离职时间</div>
            <el-date-picker
              size="mini"
              v-model="dimissionTime"
              class="ipt-sty"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">签约状态</div>
            <el-select
              size="mini"
              v-model="searchData.contractState"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in signContractOption"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">在职状态</div>
            <el-select
              size="mini"
              v-model="searchData.dutyStatus"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in onJobOption"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">入职时间</div>
            <el-date-picker
              size="mini"
              v-model="entryTime"
              class="ipt-sty"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>

          <el-col :span="6">
            <div class="search-area-div">备案销售区域</div>
            <el-select
              size="mini"
              v-model="searchData.salesTerritoryGuid"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
              @visible-change="hasOrg"
            >
              <el-option
                v-for="item in areaOption"
                :key="item.guid"
                :label="item.territoryName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">选择岗位</div>
            <el-select
              size="mini"
              v-model="searchData.position"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
              @visible-change="hasCompany"
            >
              <el-option
                v-for="item in positionOption"
                :key="item.guid"
                :label="item.positionName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" style="display: flex">
            <div class="search-area-div">人员年龄</div>
            <div class="age-box">
              <el-input
                size="mini"
                v-model="searchData.startAge"
                placeholder="请输入"
                oninput="value=value.replace(/[^0-9]/g,'').replace(/^0{1,}/g, '')"
                :maxlength="3"
                @change="startAgeChange(searchData.startAge)"
              ></el-input>
              <span> 至 </span>
              <el-input
                size="mini"
                v-model="searchData.endAge"
                placeholder="请输入"
                oninput="value=value.replace(/[^0-9]/g,'').replace(/^0{1,}/g, '')"
                :maxlength="3"
                @change="endAgeChange(searchData.endAge)"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">
              <el-tooltip
                effect="light"
                class="item"
                content="再过60天就到55岁的人为【年龄超标】"
                placement="top-start"
              >
                <i class="el-icon-question">年龄超标</i>
              </el-tooltip>
            </div>
            <el-select
              size="mini"
              v-model="searchData.isOverAge"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in ageOption"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">所属服务商</div>
            <el-select
              size="mini"
              v-model="searchData.staffServiceTenantGuid"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in levyCompanyGuidList"
                :key="item.guid"
                :label="item.tenantName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">身份证号</div>
            <el-input
              class="ipt-sty"
              size="mini"
              v-model="searchData.idCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">服务类型</div>
            <el-select
              size="mini"
              v-model="searchData.levyType"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in levyTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">启用状态</div>
            <el-select
              size="mini"
              v-model="searchData.effective"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in effectiveList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">所属中心</div>
            <el-select
              size="mini"
              v-model="searchData.baseCenter"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('所属中心')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">所属大区</div>
            <el-select
              size="mini"
              v-model="searchData.baseRegion"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('所属大区')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">所属地级</div>
            <el-select
              size="mini"
              v-model="searchData.baseRegionLevel"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('所属地区')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">平台角色</div>
            <el-select
              size="mini"
              v-model="searchData.platformPositionLevel"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('平台角色')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">推广品类</div>
            <el-select
              size="mini"
              v-model="searchData.promotionCategory"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('推广品类')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">业务员能力</div>
            <el-select
              size="mini"
              v-model="searchData.staffLevel"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('业务员能力分类')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>

    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
        "
      >
        <div>
          <el-button
            size="mini"
            type="info"
            @click="$router.push('/brokerInsuredEdit')"
            >新增花名册</el-button
          >
          <el-button size="mini" type="info" @click="getInsuranceDataSync"
            >同步数据</el-button
          >
          <el-button
            size="mini"
            type="info"
            @click="$router.push('/importNewPerson')"
          >
            批量导入</el-button
          >
        </div>
        <div>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-setting"
            @click="setTableHead()"
            >设置表头</el-button
          >
          <el-button size="mini" type="info" @click="setExportHead()"
            >导出
          </el-button>
        </div>
      </div>
      <el-table
        :height="height"
        :data="tableData"
        stripe
        border
        ref="filterTable"
        style="width: 100%"
        v-loading="tableLoading"
      >
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              (searchData.pageIndex - 1) * searchData.pageSize +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <template v-for="(item, i) in allFiledData">
          <!-- show-overflow-tooltip -->
          <el-table-column
            show-overflow-tooltip
            :prop="item.fieldName"
            v-if="item.listVisible == 'Y'"
            :key="i"
            :label="item.fieldDesc"
            header-align="center"
            align="left"
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <!-- <el-popover v-if="item.fieldType == 'file'" placement="top-start" title="" width="200" trigger="hover"> -->
              <a
                v-if="item.fieldType == 'file'"
                :href="scope.row[item.fieldName] | filterFile('path')"
                target="_blank"
                class="filePopoverA"
                >{{ scope.row[item.fieldName] | filterFile("path") }}</a
              >
              <!-- <div slot="reference" class="filePopover">{{ scope.row[item.fieldName] | filterFile('name')}}</div>
                </el-popover> -->

              <!-- <el-popover placement="top-start" title="" width="200" trigger="hover"> -->
              <span
                v-else-if="
                  item.fieldName == 'staffTenantName' ||
                  item.fieldName == 'staffOrganisation'
                "
                :href="scope.row[item.fieldName]"
              >
                {{ scope.row[item.fieldName] || "-" }}
              </span>
              <!-- <span slot="reference" class="filePopover">{{ scope.row[item.fieldName] || '-'}}</span>
                </el-popover> -->

              <span v-else-if="item.fieldName === 'promotionCategory'">
                {{ scope.row['promotionCategoryName'] || "-" }}
              </span>  

              <span v-else>
                {{
                  scope.row[item.fieldName] | filterSourceData(item.dataSource)
                }}</span
              >
            </template>
          </el-table-column>
        </template>
        <el-table-column
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <span class="state" v-if="scope.row.effective == 1">启用</span>
            <span class="no-state" v-else>停用</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
          width="180"
        >
          <template slot-scope="scope">
            <a
              class="txt-color"
              style="margin-right: 10px"
              @click="viewCvInfo(scope.row)"
              >{{ isMedicalRole(scope.row.platformPositionLevel) ? "认证信息" : "简历信息" }}</a
            >
            <a class="txt-color" @click="changeState(scope.row)">
              {{ scope.row.effective == 1 ? "停用" : "启用" }}
            </a>
            <a
              class="txt-color"
              style="margin: 0 10px"
              @click="toLink(scope.row, scope.$index)"
              >编辑</a
            >
            <a
              class="txt-color"
              v-if="!flowType"
              @click="deleteStaff(scope.row, 0)"
              >删除</a
            >
            <a class="txt-color" v-else @click="deleteStaff(scope.row, 1)"
              >删除</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="searchData.pageIndex"
      :page-size="searchData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalRows"
    >
    </el-pagination>

    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="showImport"
      width="800px"
      class="importClass"
      @close="cancelImport"
    >
      <el-steps :active="currentStep" align-center>
        <el-step title="上传文件"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>
      <div class="firstStep" v-if="currentStep == 0">
        <el-row>
          <el-col :span="6"> 下载模板： </el-col>
          <el-col :span="18">
            <div>
              <a :href="templateUrl" type="download" class="downloadTemplate"
                >下载导入模板</a
              >
              <!-- <el-button type="info" @click="downloadTemplate" size="small">下载导入模板</el-button> -->
            </div>
            <div class="tipInfo">
              注意事项：<br />
              1、请先下载Excel模版，严格按照模板内容填入数据，再上传文件到系统；<br />
              2、若导入人员已存在，那么信息将会覆盖；<br />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 导入文件： </el-col>
          <el-col :span="18">
            <div>
              <el-upload
                class="avatar-uploader"
                action="#"
                :limit="1"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadImage"
                multiple
                :file-list="fileList"
              >
                <el-button size="small" type="info" :loading="importLoading"
                  >点击上传文件</el-button
                >
              </el-upload>
            </div>
            <div class="tipInfo">
              注意事项：<br />
              1、仅支持excel文件，大小&lt; =2M；<br />
              2、使用 Office 2010 及以上版本，避免出现乱码；<br />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="secondStep" v-if="currentStep == 1">
        <p class="line1">数据导入完成，请核对！</p>
        <p class="line2">
          共需导入数据<span>{{ importResult.total }}</span
          >条，导入成功<span>{{ importResult.ok }}</span
          >条
          <span v-if="importResult.error"
            >，失败<span>{{ importResult.error }}</span
            >条。</span
          >
        </p>
        <p class="line3" @click="downFailData" v-if="importResult.error > 0">
          下载导入失败数据
        </p>
      </div>
      <div slot="footer" class="dialog-footer" v-if="currentStep == 0">
        <el-button @click="cancelImport" size="small">取 消</el-button>
        <el-button
          type="info"
          @click="confirmImport"
          :loading="importLoading"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 结束 -->
    <!-- 表头设置 -->
    <el-dialog
      title="表头设置"
      :visible.sync="showSetHead"
      width="1000px"
      class="setHeadClass"
      :close-on-click-modal="false"
      @close="getGroupList()"
    >
      <div class="setHead">
        <div class="left">
          <p>全部字段（{{ allFiledData.length }}项）</p>
          <el-input
            placeholder="输入关键字进行过滤"
            size="small"
            style="margin: 6px 0"
            v-model="filterText"
          >
          </el-input>
          <el-tree
            :data="treeData"
            filter
            :filter-node-method="filterNode"
            show-checkbox
            default-expand-all
            node-key="guid"
            ref="tree"
            highlight-current
            :props="defaultProps"
            @check-change="getCheckedNodes"
          >
          </el-tree>
        </div>
        <div class="right">
          <div class="top">
            <p>已选字段（{{ selectedData.length }}项）</p>
            <div class="btnArea">
              <span @click="deleteSelected">批量删除</span>
            </div>
          </div>
          <el-table
            :data="selectedData"
            style="height: 500px; overflow-y: scroll"
            @selection-change="handleSelectionChange"
            v-loading="settingLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="字段名称"> </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <div class="opreateIcon">
                  <i
                    v-if="scope.$index + 1 != selectedData.length"
                    class="el-icon-sort-down"
                    @click="sortDownField(scope.row, scope.$index)"
                  ></i>
                  <i
                    v-if="scope.$index != 0"
                    class="el-icon-sort-up"
                    @click="sortUpField(scope.row, scope.$index)"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetHead = false" size="small">取 消</el-button>
        <el-button
          type="info"
          @click="updateFieldVisible"
          :loading="settingLoading"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 结束 -->

    <!-- 导出花名册 -->
    <el-dialog
      title="导出花名册"
      :visible.sync="showExportHead"
      width="1000px"
      class="setHeadClass"
      :close-on-click-modal="false"
    >
      <div class="setHead">
        <div class="left">
          <p>全部字段（{{ allFiledData.length }}项）</p>
          <el-input
            placeholder="输入关键字进行过滤"
            size="small"
            style="margin: 6px 0"
            v-model="exportFilterText"
          >
          </el-input>
          <el-tree
            :data="exportTreeData"
            filter
            :filter-node-method="filterNode"
            show-checkbox
            default-expand-all
            node-key="guid"
            ref="exportTree"
            highlight-current
            :props="defaultProps"
            @check-change="getExportCheckedNodes"
          >
          </el-tree>
        </div>
        <div class="right">
          <div class="top">
            <p>已选字段（{{ exportSelectedData.length }}项）</p>
            <div class="btnArea">
              <span @click="deleteExportSelected">批量删除</span>
            </div>
          </div>
          <el-table
            :data="exportSelectedData"
            style="height: 500px; overflow-y: scroll"
            @selection-change="handleSelectionChangeExport"
            v-loading="exportSettingLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="字段名称"> </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <div class="opreateIcon">
                  <i
                    v-if="scope.$index + 1 != exportSelectedData.length"
                    class="el-icon-sort-down"
                    @click="sortDownFieldExport(scope.row, scope.$index)"
                  ></i>
                  <i
                    v-if="scope.$index != 0"
                    class="el-icon-sort-up"
                    @click="sortUpFieldExport(scope.row, scope.$index)"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showExportHead = false" size="small"
          >取 消</el-button
        >
        <el-button
          type="info"
          @click="exportOut"
          :loading="exportSettingLoading"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 结束 -->
    <!-- 走流程的提示框 -->
    <el-dialog
      title="提示"
      :visible.sync="goThroughTheProcessdialogVisible"
      width="30%"
      custom-class="dialog-reason"
    >
      <div slot="title" class="dialog-title">
        {{ "填写原因" }}
      </div>
      <br />
      <div class="dialogCon">
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <!-- <p>
              <span slot="label" style="color: red">*</span>
              <span>填写原因:</span>
            </p> -->
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 7 }"
            v-model="changeCause"
            maxlength="30"
            show-word-limit
            placeholder="请填写原因"
            clearable
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
        <el-button size="small" type="info" @click="toAuditSubmit">{{
          "确认"
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
  </div>
</template>

<script>
import { route } from "@/api/apiRoute";
import store from "@/store";
import qs from "qs";
import commonSearch from "@/components/commonSearch";
export default {
  components: {
    commonSearch,
  },
  data() {
    return {
      curpObject: {},
      changeCause: "", // 删除原因
      contentMainHeight: window.innerHeight - 200,
      height: window.innerHeight - 264,
      searchShow: false,
      templateUrl: window.location.origin + "/ImportTemplate.xlsx",
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        "Content-Type": "multipart/form-data",
        Authorization: store.state.token,
      },
      //走流程的提示框
      goThroughTheProcessdialogVisible: false,
      //分页数据
      dialogTableVisible: false,

      //当前页
      currentPage4: 1,
      allGroupData: [], //所有分组数据
      allFiledData: [], //所有字段数据
      tableData: [],
      totalRows: 0,
      tableLoading: false,
      quervVO: null,
      searchData: {
        pageIndex: 1,
        pageSize: 50,
        staffOrMobileNo: null, //姓名或手机号
        dutyStatus: null, //在职状态
        entryStartDate: null, //入职时间起止
        entryEndDate: null,
        staffStatus: null, //转正状态
        regularEndDate: null, //转正时间起止
        regularStartDate: null,
        dimissionEndDate: null, //离职时间起止
        dimissionStartDate: null,
        contractState: null, //签约状态
        tenantGuid: null, //所属公司
        salesTerritoryGuid: null, //销售区域
        orgGuid: null, //部门
        position: null, //岗位
        startAge: null, //开始年龄
        endAge: null, //结束年龄
        isOverAge: "0", //0全部/1超过55岁/2未超过55岁
        staffServiceTenantGuid: null, //服务商guid
        idCode: null, //身份证号
        levyType: null, //服务类型
        effective: null, //启用状态
        promotionCategory: null, //推广品类
        platformPositionLevel: null, //平台角色
        baseRegionLevel: null, //所属地级
        baseCenter: null, //所属中心
        staffLevel:null,
      },
      levyTypeList: [
        {
          name: "终端服务",
          value: "1",
        },
        {
          name: "数据采集",
          value: "2",
        },
      ],
      effectiveList: [
        {
          name: "启用",
          value: 1,
        },
        {
          name: "停用",
          value: 0,
        },
      ],

      entryTime: [], //入职时间组件
      regularTime: [], //转正时间组件
      dimissionTime: [], //离职时间组件
      tenantGuidOption: [], //公司机构下拉
      areaOption: [], //销售区域下拉
      orgGuidOption: [], //组织机构下拉
      positionOption: [], //岗位下拉
      onJobOption: [
        //在职状态
        {
          name: "在职",
          value: "1",
        },
        {
          name: "留职",
          value: "2",
        },
        {
          name: "离职",
          value: "3",
        },
        {
          name: "取消入职",
          value: "4",
        },
        {
          name: "待入职",
          value: "5",
        },
      ],
      regularStatusOption: [
        //转正状态
        {
          name: "正式",
          value: "1",
        },
        {
          name: "试用",
          value: "2",
        },
      ],
      signContractOption: [
        //签约状态
        {
          name: "待签约",
          value: "W",
        },
        {
          name: "履约中",
          value: "Y",
        },
        {
          name: "已到期",
          value: "E",
        },
        // {
        //   name: "已解约",
        //   value: "S"
        // }
      ],
      ageOption: [
        {
          name: "全部",
          value: "0",
        },
        {
          name: "已超标",
          value: "1",
        },
        {
          name: "未超标",
          value: "2",
        },
      ],
      fullscreenLoading: false,
      //批量导入
      showImport: false,
      currentStep: 0,
      importResult: "",
      importLoading: false,
      fileList: [], //上传的文件
      //表头设置
      showSetHead: false,
      defaultProps: {
        children: "tableData",
        label: "name",
      },
      treeData: [],
      settingLoading: false,
      filterText: "", //树节点过滤
      selectedData: [], //树选中
      tableSelected: [], //表格选中
      //导出花名册设置
      showExportHead: false,
      exportTreeData: [],
      exportSettingLoading: false,
      exportFilterText: "", //树节点过滤
      exportSelectedData: [], //树选中
      exportTableSelected: [], //表格选中
      flowType: null,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    exportFilterText(val) {
      this.$refs.exportTree.filter(val);
    },
    searchShow(val, oldVal) {
      if (val) {
        this.height = window.innerHeight - 500;
        this.contentMainHeight = window.innerHeight - 450;
        return;
      }
      if (!val) {
        this.height = window.innerHeight - 264;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path) {
      next((vm) => {
        vm.getData(() => {
          if (vm.$store.getters.getPageY) vm.tableScrollToRow(vm.$refs.filterTable, vm.$store.getters.getPageY); // 表格行跳转
        });
      });
    } else {
      next();
    }
  },
  created() {
    this.getDeleteApproval();
    if (this.$route.query.isOverAge) {
      this.searchData.isOverAge = "1";
    }
    if (this.$route.query.dutyStatus) {
      this.searchData.dutyStatus = this.$route.query.dutyStatus;
    }
    this.getGroupList();
    this.getDict();
    this.comfirmSearch();
    this.getServiceTenantList();
  },
  filters: {
    filterSourceData(val, dataSource) {
      //处理表格字段
      let str = val;
      let options = dataSource ? JSON.parse(dataSource) : [];

      options.forEach((item) => {
        if (item.value == val) {
          str = item.name;
        }
      });
      return str || "-";
    },
    filterFile(val, type) {
      //处理图片显示
      //是json
      try {
        let obj = JSON.parse(val);
        return type == "path" ? obj.path : obj.fileName;
      } catch (e) {}
      //不是
      return val;
    },
  },
  methods: {
    handleClose() {},
    //分页处理
    paginaTion() {
      this.dialogTableVisible = true;
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/staff/data/list-exist-other-bkp-companies`
        )
        .then((res) => {
        });
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(vall) {
      // this.pageIndex=vall
    },

    //获取服务商
    getServiceTenantList() {
      let self = this;
      let params = {
        quervVO: this.quervVO,
      };
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`,
          params
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.levyCompanyGuidList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //表头设置
    setTableHead(type) {
      this.treeData = JSON.parse(JSON.stringify(this.allGroupData));
      //设置树组件选中数据
      let data = [];
      this.treeData.forEach((item) => {
        item.tableData.forEach((one) => {
          if (one.listVisible == "Y") {
            data.push(one);
          }
        });
      });
      this.selectedData = data;
      this.selectedData.sort((a, b) => {
        return a.listOrderNum - b.listOrderNum;
      });
      this.showSetHead = true;
      let that = this;
      that.$nextTick(function () {
        that.$refs.tree.setCheckedNodes(data);
      });
    },
    //表头设置-获取树选中节点
    getCheckedNodes() {
      this.selectedData = this.$refs.tree.getCheckedNodes(true); //只包含子节点
      this.selectedData.sort((a, b) => {
        return a.listOrderNum - b.listOrderNum;
      });
    },
    //表头设置-过滤树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 表头设置 -获取表格选中
    handleSelectionChange(val) {
      this.tableSelected = val;
    },
    //表头设置-批量删除
    deleteSelected() {
      if (this.tableSelected.length == 0) {
        this.$message.error("请勾选需要删除的内容");
        return;
      }
      this.selectedData = this.$refs.tree.getCheckedNodes(true);
      let newArr = [];
      newArr = this.selectedData.filter((item) =>
        this.tableSelected.every((one) => one.guid !== item.guid)
      );
      this.$refs.tree.setCheckedNodes(newArr); //设置树组件的选中
    },
    //表头设置-向下
    sortDownField(row, index) {
      let orderNumFlag = row.listOrderNum;
      row.listOrderNum = this.selectedData[index + 1].listOrderNum;
      this.selectedData[index + 1].listOrderNum = orderNumFlag;
      this.selectedData.splice(index, 1);
      this.selectedData.splice(index + 1, 0, row);
    },
    //表头设置-向上
    sortUpField(row, index) {
      let orderNumFlag = row.listOrderNum;
      row.listOrderNum = this.selectedData[index - 1].listOrderNum;
      this.selectedData[index - 1].listOrderNum = orderNumFlag;
      this.selectedData.splice(index, 1);
      this.selectedData.splice(index - 1, 0, row);
    },
    //更新字段排序
    updateFieldSort(dragField, currentField) {
      let that = this;
      let newPromise = new Promise(function (resolve, reject) {
        that.api
          .put(
            `/${serverConfig.msConfigureService}/cfg/field/update`,
            dragField
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              resolve();
            } else {
              that.$message.error(res.data.msg);
            }
          });
      });
      newPromise.then(function () {
        that.api
          .put(
            `/${serverConfig.msConfigureService}/cfg/field/update`,
            currentField
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            } else {
              that.$message.error(res.data.msg);
            }
          });
      });
    },
    //开始年龄
    startAgeChange(val) {
      if (Number(val) > 100) {
        this.$message.error("请输入1-100之间的数字");
        this.searchData.startAge = null;
        return;
      }
      if (
        Number(val) > Number(this.searchData.endAge) &&
        val &&
        this.searchData.endAge
      ) {
        this.searchData.startAge = null;
        this.$message.error("开始年龄不能大于截止年龄");
      }
    },
    //结束年龄
    endAgeChange(val) {
      if (Number(val) > 100) {
        this.$message.error("请输入1-100之间的数字");
        this.searchData.endAge = null;
        return;
      }
      if (
        Number(val) < Number(this.searchData.startAge) &&
        val &&
        this.searchData.startAge
      ) {
        this.searchData.endAge = null;
        this.$message.error("截止年龄不能大于开始年龄");
      }
    },
    //表头设置-更新字段是否显示
    updateFieldVisible() {
      this.settingLoading = true;
      this.selectedData.forEach((item) => {
        item.listVisible = "Y";
      });
      let newArr = this.allFiledData.filter((item) =>
        this.selectedData.every((one) => one.guid !== item.guid)
      );

      newArr.forEach((item) => {
        item.listVisible = "N";
      });

      let resultArr = newArr.concat(this.selectedData);
      resultArr.forEach((item, index) => {
        item.listOrderNum = index;
      });
      this.api
        .put(
          `/${serverConfig.msConfigureService}/cfg/field/update-list`,
          resultArr
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.showSetHead = false;
            this.$message.success("表头设置成功!");
          } else {
            this.$message.error(res.data.msg);
          }
          this.settingLoading = false;
        });
    },
    //导入-上传文件
    uploadImage(file) {
      let formData = new FormData();
      formData.append("file", file.file, file.filename);
      this.importLoading = true;
      let progressGuid = this.generateUUID();

      this.api
        .postFile(
          `/${serverConfig.msPersonnelService}/staff-roster/import?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`,
          formData
        )
        .then((res) => {
          this.importLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.importResult = res.data.data;
            this.$message.success("上传成功");
          } else {
            this.$message.error("上传失败,请重新上传!");
          }
        })
        .catch(() => {
          this.$message("上传失败,请重新上传");
        });
    },
    //导入-上传前校验
    beforeAvatarUpload(file) {
      let testmsg = file.name ? file.name.split(".")[1] : "";
      const isJPG =
        testmsg === "xls" || testmsg === "xlsx" || testmsg === "xlsm";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("文件格式不正确!");
      }
      if (!isLt2M) {
        this.$message.error("文件大小不能超过2MB!");
      }
      return isJPG && isLt2M;
    },
    //导入-生成progressGuid
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    //导入-取消
    cancelImport() {
      this.showImport = false;
      this.importResult = "";
      this.currentStep = 0;
      this.fileList = [];
      this.getData();
    },
    //导入-确定
    confirmImport() {
      if (this.importResult) {
        this.currentStep = 1;
        this.fileList = [];
      } else if (this.fileList.length == 0) {
        this.$message.error("请选择文件！");
      } else {
        this.$message.error("上传失败！");
      }
    },
    //导入-下载导入失败数据
    downFailData() {
      let params = {
        guid: "",
        tenantGuid: this.$store.state.guid,
      };
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff-roster/import/get-error-report`,
          params
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.reportJx(
              res.data.data.colNames,
              res.data.data.datas,
              res.data.data.sheetName,
              res.data.data.fileNam,
              res.data.data.dataComments
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //删除人员
    deleteStaff(pObject, type) {
      this.$confirm("确定删除 " + pObject.name + " 吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.tableLoading = true
          let guids = [pObject.guid];
          if (type == 0) {
            //非流程
            this.api
              .postJson(
                `/${serverConfig.msPersonnelService}/staff-roster/delete`,
                guids
              )
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  this.$message.success("操作成功！");

                  this.getData();
                  //  this.tableLoading = false
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          } else {
            // 删除原因填写
            this.curpObject = pObject;
            this.changeCause = "";
            this.goThroughTheProcessdialogVisible = true;
          }
        })
        .catch(() => {
          /* 已取消 */
        });
    },
    toAuditSubmit() {
      this.goThroughTheProcessdialogVisible = false;
      //走流程
      let userInfo = JSON.parse(localStorage.userInfo);
      let params = [
        {
          tenantGuid: this.$store.state.guid,
          rosterParam: this.curpObject,
          staffGuid: userInfo.staffGuid,
          guid: this.curpObject.guid,
          actionType: "save",
          funcCode: "HMCGL",
          changeCause: this.changeCause,
        },
      ];
      this.fullscreenLoading = true;
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff-roster/workflow/delete-roster-approval`,
          params
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(
              "数据删除已发起审批，待全部审批结束后，数据才正式删除成功！"
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //判断该变更是否走流程
    getDeleteApproval() {
      let req = {
        flowOperationType: 3,
        functionCode: "HMCGL",
        tenantGuid: localStorage.guid,
      };
      this.api
        .get(
          `/${serverConfig.msConfigureService}/function-workflow/data/get-flow-template-guid`,
          req
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.flowType = res.data.data.flowType;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //停用0 启用1 逻辑
    // changeState(pObject) {
    //   let self=this
    //   pObject = JSON.parse(JSON.stringify(pObject))
    //   let params = {
    //     tenantGuid: this.$store.state.guid,
    //     rosterParam: pObject,
    //     staffRecordTenantGuid: pObject.sendTenantGuid,
    //     guid: pObject.guid,
    //     staffGuid: pObject.guid
    //   }
    //   pObject.effective == 1 ? params.rosterParam.effective = 0 : params.rosterParam.effective = 1;
    //   if(params.rosterParam.effective = 0){

    //   }
    //   self.$confirm('删除后不可恢复，确定删除吗？','提示',{
    //     confirmButtonText:'确定',
    //     cancelButtonText:'取消',
    //     type:'warning',
    //   }).then(()=>{
    //      self.api.put(`/${serverConfig.msPersonnelService}/staff-roster/save-or-update`, params).then(res => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

    //       self.$message.success(pObject.effective == 0 ? '停用成功！' : '启用成功!');
    //       self.getData()
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    //   })

    // },
    changeState(pObject) {
      let self = this;
      pObject = JSON.parse(JSON.stringify(pObject));
      let params = {
        tenantGuid: this.$store.state.guid,
        rosterParam: pObject,
        staffRecordTenantGuid: pObject.sendTenantGuid,
        guid: pObject.guid,
        staffGuid: pObject.guid,
      };
      pObject.effective == 1
        ? (params.rosterParam.effective = 0)
        : (params.rosterParam.effective = 1);
      if (pObject.effective === 1) {
        self
          .$confirm("确定启用吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            self.api
              .put(
                `/${serverConfig.msPersonnelService}/staff-roster/save-or-update`,
                params
              )
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.$message.success(
                    params.rosterParam.effective == 0
                      ? "停用成功！"
                      : "启用成功!"
                  );
                  self.getData();
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          });
      } else if (pObject.effective === 0) {
        self
          .$confirm("确定停用吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            self.api
              .put(
                `/${serverConfig.msPersonnelService}/staff-roster/save-or-update`,
                params
              )
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.$message.success(
                    pObject.effective == 0 ? "停用成功！" : "启用成功!"
                  );
                  self.getData();
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          });
      }
    },
    // 是否医疗类平台角色(v26.3.3：医生14/护士15/技师16/药师17/医学生18)
    isMedicalRole(platformPositionLevel) {
      return ["14", "15", "16", "17", "18"].includes(String(platformPositionLevel || ""));
    },
    // 跳转简历详情（医疗类角色改为查看认证信息）
    viewCvInfo(item) {
      if (this.isMedicalRole(item.platformPositionLevel)) {
        this.viewCertInfo(item);
        return;
      }
      this.getCvInfo(item.idCode);
    },
    // 通过花名册guid获取认证资料并跳认证审核详情(v26.3.3)
    viewCertInfo(item) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/staff-cert/detail-by-roster?rosterGuid=` +
            encodeURIComponent(item.guid) + `&tenantGuid=${encodeURIComponent(localStorage.guid || '')}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data) {
              this.$message.error("暂无认证信息");
              return;
            }
            this.$router.push({
              path: `/certAuditManageDetail`,
              query: {
                rosterGuid: item.guid,
                readonly: "1",
              },
            });
          }
        });
    },
    // 通过身份证获取简历详情
    getCvInfo(idCode) {
      let self = this;
      let query = {
        keyword: idCode,
      };
      if (!query.keyword) return;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff-resume/data/get-detail?keyword=${query.keyword}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data) {
              this.$message.error("暂无简历信息");
              return;
            }
            this.$router.push({
              path: `/cvInforReview`,
              query: {
                idCode,
                productGuid: this.$route.query.productGuid,
              },
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 数据同步
    getInsuranceDataSync() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msUserRemunerationService}/labrocontract/data/insurance-data-sync`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success("同步完成");
            // self.$message.error(res.data.data.errorMsg);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 清空
    empty() {
      this.searchData = {
        pageIndex: 1,
        pageSize: 50,
        staffOrMobileNo: null, //姓名或手机号
        dutyStatus: null, //在职状态
        entryStartDate: null, //入职时间起止
        entryEndDate: null,
        staffStatus: null, //转正状态
        regularEndDate: null, //转正时间起止
        regularStartDate: null,
        dimissionEndDate: null, //离职时间起止
        dimissionStartDate: null,
        contractState: null, //签约状态
        tenantGuid: null, //所属公司
        salesTerritoryGuid: null, //销售区域
        orgGuid: null, //部门
        position: null, //岗位
        staffServiceTenantGuid: null,
        startAge: null, //开始年龄
        endAge: null, //结束年龄
        isOverAge: "0",
        staffServiceTenantGuid: null, //服务商guid
        idCode: null, //身份证号
        levyType: null, //服务类型
        effective: null, //启用状态
        promotionCategory: null, //推广品类
        staffLevel:null,
        platformPositionLevel: null, //平台角色
        baseRegionLevel: null, //所属地级
        baseCenter: null, //所属中心
        baseRegion: null, //所属大区
        staffServiceTenantName: null, //所属服务商
      };
      this.entryTime = []; //入职时间组件
      this.regularTime = []; //转正时间组件
      this.dimissionTime = [];
      this.getData();
    },
    //确认搜索
    comfirmSearch() {
      this.searchData.pageIndex = 1;
      this.getData();
    },
    //获取分组列表
    getGroupList(type) {
      let params = {
        pageSize: 100,
        pageIndex: 1,
        groupName: "",
        tenantGuid: this.$store.state.guid,
      };
      this.api
        .get(`/${serverConfig.msConfigureService}/cfg/group/list`, params)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data.records ? res.data.data.records : [];

            data.sort((a, b) => {
              return a.orderNum - b.orderNum;
            });
            this.allGroupData = data;
            this.getFieldList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取字段列表
    getFieldList() {
      let params = {
        pageSize: 500,
        pageIndex: 1,
        tenantGuid: this.$store.state.guid,
        chineseName: "",
        fieldType: "",
      };
      this.api
        .get(`/${serverConfig.msConfigureService}/cfg/field/list`, params)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.allFiledData = res.data.data.records
              ? res.data.data.records
              : [];
            this.allFiledData.sort((a, b) => {
              return a.listOrderNum - b.listOrderNum;
            });

            //处理成树组件数据
            this.allGroupData.forEach((item) => {
              let tableData = [];
              this.allFiledData.forEach((oneData) => {
                oneData.name = oneData.fieldDesc;
                if (oneData.groupGuid == item.guid) {
                  tableData.push(oneData);
                }
              });

              tableData.sort((a, b) => {
                return a.listOrderNum - b.listOrderNum;
              });
              item.tableData = tableData;
              this.$set(item, "tableData", tableData);
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 列表
    getData(callBack) {
      if (this.entryTime && this.entryTime.length) {
        this.searchData.entryStartDate = this.entryTime[0];
        this.searchData.entryEndDate = this.entryTime[1];
      } else {
        this.searchData.entryStartDate = "";
        this.searchData.entryEndDate = "";
      }
      if (this.regularTime && this.regularTime.length) {
        this.searchData.regularStartDate = this.regularTime[0];
        this.searchData.regularEndDate = this.regularTime[1];
      } else {
        this.searchData.regularStartDate = null;
        this.searchData.regularEndDate = null;
      }
      if (this.dimissionTime && this.dimissionTime.length) {
        this.searchData.dimissionStartDate = this.dimissionTime[0];
        this.searchData.dimissionEndDate = this.dimissionTime[1];
      } else {
        this.searchData.dimissionStartDate = "";
        this.searchData.dimissionEndDate = "";
      }
      this.tableLoading = true;
      let url = `/${serverConfig.msPersonnelService}/staff-roster/list`;
      this.api.postJson(url, this.searchData).then((res) => {
        this.$nextTick(() => {
          this.$refs.filterTable.doLayout();
          if (callBack) callBack();
        });
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData = res.data.data.records || [];
          if (res.data.data.records) {
            this.totalRows = res.data.data.totalRows;
          } else {
            this.totalRows = 0;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    toLink(item,index) {
      this.setPageIndex(index)
      this.$router.push({
        path: "/brokerInsuredDetail",
        query: {
          item: JSON.stringify(item),
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    // 花名册导出---------------------------------------------------------------------------------
    setExportHead(type) {
      this.exportTreeData = JSON.parse(JSON.stringify(this.allGroupData));
      //设置树组件选中数据
      let data = [];
      this.exportTreeData.forEach((item) => {
        item.tableData.forEach((one) => {
          if (one.listVisible == "Y") {
            data.push(one);
          }
        });
      });
      this.exportSelectedData = data;
      this.exportSelectedData.sort((a, b) => {
        return a.listOrderNum - b.listOrderNum;
      });
      this.showExportHead = true;
      let that = this;
      that.$nextTick(function () {
        that.$refs.exportTree.setCheckedNodes(data);
      });
    },
    //花名册导出-获取树选中节点
    getExportCheckedNodes() {
      this.exportSelectedData = this.$refs.exportTree.getCheckedNodes(true); //只包含子节点
      this.exportSelectedData.sort((a, b) => {
        return a.listOrderNum - b.listOrderNum;
      });
    },
    // 花名册导出 -获取表格选中
    handleSelectionChangeExport(val) {
      this.exportTableSelected = val;
    },
    //花名册导出-批量删除
    deleteExportSelected() {
      if (this.exportTableSelected.length == 0) {
        this.$message.error("请勾选需要删除的内容");
        return;
      }
      this.exportSelectedData = this.$refs.exportTree.getCheckedNodes(true);
      let newArr = [];
      newArr = this.exportSelectedData.filter((item) =>
        this.exportTableSelected.every((one) => one.guid !== item.guid)
      );
      this.$refs.exportTree.setCheckedNodes(newArr); //设置树组件的选中
    },
    //花名册导出-向下
    sortDownFieldExport(row, index) {
      let orderNumFlag = row.listOrderNum;
      row.listOrderNum = this.exportSelectedData[index + 1].listOrderNum;
      this.exportSelectedData[index + 1].listOrderNum = orderNumFlag;
      this.exportSelectedData.splice(index, 1);
      this.exportSelectedData.splice(index + 1, 0, row);
    },
    //花名册导出-向上
    sortUpFieldExport(row, index) {
      let orderNumFlag = row.listOrderNum;
      row.listOrderNum = this.exportSelectedData[index - 1].listOrderNum;
      this.exportSelectedData[index - 1].listOrderNum = orderNumFlag;
      this.exportSelectedData.splice(index, 1);
      this.exportSelectedData.splice(index - 1, 0, row);
    },
    //执行导出
    exportOut() {
      let data = [];
      this.exportSelectedData.forEach((item) => {
        let obj = {
          fieldName: item.fieldName,
        };
        data.push(obj);
      });
      let params = JSON.parse(JSON.stringify(this.searchData));
      params.pageSize = -1;
      this.exportSettingLoading = true;
      this.api
        .postJson(
          `/${
            serverConfig.msPersonnelService
          }/staff-roster/export?${qs.stringify(params)}`,
          data
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.reportJx(
              res.data.data.colNames,
              res.data.data.datas,
              res.data.data.sheetName,
              res.data.data.fileNam
            );
          } else {
            this.$message.error(res.data.msg);
            this.exportSettingLoading = false;
          }
        });
    },
    reportJx(colNames, datas, sheetName, fileNam, dataComments) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
          dataComments: dataComments ? dataComments : [],
        })
        .then((res) => {
          self.exportSettingLoading = false;
          self.showExportHead = false;
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    handleSizeChange(val) {
      this.searchData.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.searchData.pageIndex = val;
      this.getData();
    },
    //运营获取药企
    getDict() {
      let self = this;
      self.powerTenantNames = [];
      let query={
        pageIndex: 1,
        pageSize: -1,
        memberStatus:'ZSHY'
        // queryAllServiceTenantFlag: false, // 是否查询所有的运营公司 true是 false否
        // currentTenantGuid: localStorage.guid,
      }
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantGuidOption = res.data.data.records? res.data.data.records : [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //筛选选中公司获取其他参数
    chooseCompany() {
      this.searchData.salesTerritoryGuid = "";
      this.searchData.orgGuid = "";
      this.searchData.position = "";
      this.areaOption = [];
      this.orgGuidOption = [];
      this.positionOption = [];
      if (!this.searchData.tenantGuid) return;
      let params = {
        pageSize: -1,
        pageIndex: 1,
        tenantGuid: this.searchData.tenantGuid,
      };
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/position/data/get`,
          params
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.positionOption = res.data.data.records
              ? res.data.data.records
              : [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/organisation/data/get`,
          params
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.orgGuidOption = res.data.data.records
              ? res.data.data.records
              : [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 选择组织机构获取销售区域
    chooseOrg() {
      this.searchData.salesTerritoryGuid = "";
      this.areaOption = [];
      if (this.searchData.tenantGuid && this.searchData.orgGuid) {
        let params = {
          pageSize: -1,
          pageIndex: 1,
          tenantGuid: this.searchData.tenantGuid,
          organisationGuids: [this.searchData.orgGuid],
        };
        this.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`,
            params
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.areaOption = res.data.data.records
                ? res.data.data.records
                : [];
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    //判断是否选中公司
    hasCompany(type) {
      if (type && !this.searchData.tenantGuid) {
        this.$message.error("请先选择备案公司！");
      }
    },
    //判断是否选中公司和组织
    hasOrg(type) {
      if (type) {
        if (!this.searchData.tenantGuid) {
          this.$message.error("请先选择备案公司！");
        } else if (!this.searchData.orgGuid) {
          this.$message.error("请先选择备案部门！");
        }
      }
    },
    setPageIndex(index) {
      this.$store.commit('setPageY', index);
    },
    /**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>
<style scoped>
.content .el-col-5 {
  margin-bottom: 15px;
}

.content /deep/ .el-checkbox__label {
  display: none;
}

.content /deep/ .el-input__icon {
  line-height: 36px;
  height: 36px;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/* 导入 */
.importClass .firstStep {
  text-align: left;
  margin-top: 50px;
}

.importClass .firstStep .el-row {
  margin-bottom: 50px;
}

.importClass .firstStep .el-col-6 {
  text-align: right;
}

.importClass .firstStep .tipInfo {
  line-height: 26px;
  color: #999;
  margin-top: 10px;
}

.importClass .secondStep {
  margin-top: 50px;
  height: 290px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}

/* 表头设置 */
.setHeadClass .setHead {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.setHeadClass .setHead p {
  margin: 0;
}

.setHeadClass .setHead .left {
  width: 300px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  margin-right: 10px;
  height: 556px;
  overflow-y: scroll;
}

.setHeadClass .setHead .right {
  flex: 1;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
}

.setHeadClass .setHead .right .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.btnArea span {
  text-decoration: underline;
  color: #4fa1a4;
  margin-left: 12px;
  cursor: pointer;
}

.opreateIcon {
  display: inline-block;
  width: 80px;
  text-align: left;
}

.opreateIcon i {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding: 2px 6px;
  margin-left: 4px;
}

.opreateIcon i:hover {
  color: #4fa1a4;
}

.el-col-5 {
  display: flex;
}
</style>
